<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="group-questions" tabindex="0" aria-labelledby="choiceGroupQuestionAria">
  <div class="question-aria" id="choiceGroupQuestionAria">{{ 'translations.choiceGroupQuestionAria' | transloco }}</div>

  @if (question?.questionTarget?.feedbackProvider && isFeedbackFor) {
    <ptl-resource-preview
      class="question-description"
      [previewContent]="[
        {
          type: 'PARAGRAPH',
          content: question.feedbackProviderInstructions ? getTranslatedValue(question.feedbackProviderInstructions) : null,
        },
      ]"
    >
    </ptl-resource-preview>
  } @else {
    <ptl-resource-preview class="question-description" [previewContent]="[{ type: 'PARAGRAPH', content: instruction }]">
    </ptl-resource-preview>
  }

  <div class="scroll-content">
    <table class="question-table">
      <thead>
        <tr class="question-table-row header-row">
          <th class="question-column"></th>
          <th class="option-column" *ngFor="let title of optionsTitle; let i = index">
            <div class="small">
              {{ title }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="question-table-row" *ngFor="let item of formattedQuestions; let questionIndex = index">
          <td class="question-column instruction">
            <div class="medium">{{ item.instruction.value }}</div>
          </td>
          <ng-container *ngFor="let option of item.options; let optionIndex = index">
            <td class="option-column" *ngIf="!isTablet">
              <div
                class="option-circle"
                [class.is-selected]="option.selected"
                tabindex="0"
                [attr.aria-label]="
                  option.selected
                    ? ('translations.global.ariaLabels.questionSelectedOption'
                      | transloco: { number: optionIndex + 1, name: optionsTitle[optionIndex] })
                    : ('translations.global.ariaLabels.questionOption'
                      | transloco: { number: optionIndex + 1, name: optionsTitle[optionIndex] })
                "
                (click)="selectAnswer(questionIndex, optionIndex)"
                (keydown.space)="selectAnswer(questionIndex, optionIndex)"
                (keydown.enter)="selectAnswer(questionIndex, optionIndex)"
              ></div>
            </td>

            <td
              class="option-column"
              *ngIf="isTablet"
              tabindex="0"
              [attr.aria-label]="
                option.selected
                  ? ('translations.global.ariaLabels.questionSelectedOption'
                    | transloco: { number: optionIndex + 1, name: optionsTitle[optionIndex] })
                  : ('translations.global.ariaLabels.questionOption'
                    | transloco: { number: optionIndex + 1, name: optionsTitle[optionIndex] })
              "
              (click)="selectAnswer(questionIndex, optionIndex)"
              (keydown.space)="selectAnswer(questionIndex, optionIndex)"
              (keydown.enter)="selectAnswer(questionIndex, optionIndex)"
            >
              <div class="option-circle" [class.is-selected]="option.selected"></div>
              <div class="option-title small">{{ optionsTitle[optionIndex] }}</div>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>
